module.exports = __webpack_public_path__ + "media/images/profile/fallback-avatar-19939fcec472869c31aafe8b834920c5.jpg";